const SIGN_UP_FORM_ID = 'signup-form';
const LOG_IN_FORM_ID = 'login-form';
const CREATE_USERNAME_FORM_ID = 'create-username-form';
const FORGOT_PASSWORD_FORM_ID = 'forgot-password-form';
const RESET_PASSWORD_FORM_ID = 'reset-password-form';
const RESEND_EMAIL_FORM_ID = 'resend_email-form';

const FORM_BUTTON_LABELS: { [key: string]: string } = {
  [LOG_IN_FORM_ID]: 'Log In',
  [SIGN_UP_FORM_ID]: 'Create account',
  [CREATE_USERNAME_FORM_ID]: 'Next',
  [RESEND_EMAIL_FORM_ID]: 'Resend email',
  [FORGOT_PASSWORD_FORM_ID]: 'Send link',
  [RESET_PASSWORD_FORM_ID]: 'Save Password',
};

const USERNAME_ALLOWED_CHARS_REGEX = /[^a-zA-Z0-9._-]/;
const USERNAME_VALIDATION_REGEX = /^(?=(?:.*[a-zA-Z]){3,})[a-zA-Z0-9._-]+$/;

export {
  FORM_BUTTON_LABELS,
  LOG_IN_FORM_ID,
  SIGN_UP_FORM_ID,
  CREATE_USERNAME_FORM_ID,
  FORGOT_PASSWORD_FORM_ID,
  RESEND_EMAIL_FORM_ID,
  RESET_PASSWORD_FORM_ID,
  USERNAME_ALLOWED_CHARS_REGEX,
  USERNAME_VALIDATION_REGEX,
};
